module.exports = __webpack_public_path__ + "static/media/180Bar.47878da6.svg";